export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `42-44`, `44-46`, `48`, `50`, `52`],
  [`Грудь`, `40`, `44`, `48`, `50`, `54`],
  [`Длина`, `60`, `62`, `64`, `65`, `67`]
];
